import { c as _c } from "react/compiler-runtime";
// React Imports
import type { Theme } from '@mui/material';
import React from 'react';

// MUI Imports

const IconChecked = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 18.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Z" fill="var(--mui-palette-common-white)" stroke="currentColor" strokeWidth="5" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const UncheckedIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z" stroke="var(--mui-palette-text-secondary)" strokeWidth="2" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const radio: Theme['components'] = {
  MuiRadio: {
    defaultProps: {
      icon: <UncheckedIcon />,
      checkedIcon: <IconChecked />
    },
    styleOverrides: {
      root: ({
        theme,
        ownerState
      }) => ({
        ...(ownerState.size === 'small' ? {
          padding: theme.spacing(1),
          '& svg': {
            fontSize: '1.25rem'
          }
        } : {
          padding: theme.spacing(1.5),
          '& svg': {
            fontSize: '1.5rem'
          }
        }),
        '&.Mui-checked:not(.Mui-disabled) svg': {
          filter: 'drop-shadow(var(--mui-customShadows-xs))'
        },
        '&.Mui-disabled': {
          opacity: 0.5,
          cursor: 'not-allowed',
          '&:not(.Mui-checked)': {
            color: 'var(--mui-palette-text-disabled)'
          },
          '&.Mui-checked.MuiRadio-colorPrimary': {
            color: 'var(--mui-palette-primary-main)',
            opacity: 0.6
          },
          '&.Mui-checked.MuiRadio-colorSecondary': {
            color: 'var(--mui-palette-secondary-main)',
            opacity: 0.6
          },
          '&.Mui-checked.MuiRadio-colorError': {
            color: 'var(--mui-palette-error-main)',
            opacity: 0.6
          },
          '&.Mui-checked.MuiRadio-colorWarning': {
            color: 'var(--mui-palette-warning-main)',
            opacity: 0.6
          },
          '&.Mui-checked.MuiRadio-colorInfo': {
            color: 'var(--mui-palette-info-main)',
            opacity: 0.6
          },
          '&.Mui-checked.MuiRadio-colorSuccess': {
            color: 'var(--mui-palette-success-main)',
            opacity: 0.6
          },
          '& svg': {
            filter: 'grayscale(50%)'
          }
        }
      })
    }
  }
};
export { radio };